var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "SF 60x60@2x",
    fill: "#fff",
    stroke: "#eaeaea"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 73",
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 84",
    d: "M31 14v-4a1 1 0 00-1-1H10a1 1 0 00-1 1v4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 85",
    d: "M9 16v14a1 1 0 001 1h5V16z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 86",
    d: "M31 16v4.08A7.906 7.906 0 0027 19a8.011 8.011 0 00-8 8 7.906 7.906 0 001.08 4H17V16z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 87",
    d: "M27 21a6 6 0 106 6 6.018 6.018 0 00-6-6z",
    fill: "#ef5323"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 33",
    fill: "#fff",
    d: "M26.25 23.5h1.5v4.375h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 34",
    fill: "#fff",
    d: "M30.248 28.413l-.75 1.299-3.248-1.875.75-1.299z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.706ee192764809e59447b83071d808e1.svg";
export { ForwardRef as ReactComponent };